import React, { useEffect, useRef } from "react";
import "./HeroSection.css";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import mainImage from "../assets/main.webp";

gsap.registerPlugin(ScrollTrigger);

const HeroSection: React.FC = () => {
  const heroRef = useRef<HTMLDivElement>(null);
  // const overlayRef = useRef<HTMLDivElement>(null);
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // 初期状態: オーバーレイとコンテンツを非表示
    gsap.set([contentRef.current], { opacity: 0 });

    // スクロールに応じてオーバーレイとコンテンツをフェードイン
    gsap.to([contentRef.current], {
      scrollTrigger: {
        trigger: heroRef.current,
        start: "top top",
        end: "50% top",
        scrub: true,
      },
      opacity: 1,
      ease: "none",
    });
  }, []);

  return (
    <section
      className="hero-section"
      ref={heroRef}
      aria-label="メインビジュアル"
    >
      <div
        className="hero-background"
        style={{ backgroundImage: `url(${mainImage})` }}
        role="img"
        aria-label="電子コミック制作の背景画像"
      ></div>
      <div className="hero-content" ref={contentRef}>
        <h1 className="hero-title">eComicシリーズ</h1>
        <p className="hero-subtitle">
          まんがにこだわる共同印刷の
          <br />
          最新技術を紹介します
        </p>
      </div>
      <div className="scroll-indicator" aria-hidden="true">
        <div className="scroll-arrow"></div>
      </div>
    </section>
  );
};

export default HeroSection;
